import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch, useSelector } from "react-redux";
import { uploadFileApi } from "../../services/UploadFile";
import {
  Box,
  Grid,
  Button,
  Tooltip,
  IconButton,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ClipLoader from "react-spinners/ClipLoader";
import { CSSProperties } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { pushNotification } from "../../redux/actions";
import CONSTANTS from "../../constants/constants";
import { deleteDocument, downloadFile } from "../../services/DocumentService";
import Colors from "../../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  fileUploadContainer: {
    width: "100%",
  },
  fileDisplayConatiner: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid  #C3C3C3",
    borderRadius: "15px",
    padding: "1%",
  },
  fileTitle: {
    width: "35%",
    wordWrap: "break-word",
  },
  DocumentTitleContainer: {
    display: "flex",
    color: theme.palette.secondary.main,
    fontSize: theme.fontSizes.SMALL,
    fontWeight: 600,
    paddingBottom: "3%",
  },
  uploadSuccess: {
    color: Colors.GREEN,
  },
  uploadFailed: {
    color: Colors.RED,
  },
  fileTypeImg: {
    height: "2.5rem",
    width: "2.5rem",
  },
}));

const DocumentUpload = ({ formOne, field, title }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { proposalDataRedux } = useSelector((state: any) => ({
    proposalDataRedux: state.proposalData,
  }));

  const [fileData, setFileData] = useState<any>({});
  const fileTypes = ["JPG", "PNG", "PDF"];
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (file) => {
    setLoading(true);
    setFile(file);
    const response: any = await uploadFileApi(
      file.name,
      file,
      "insurproPolicyData",
      {
        docCategory: file.type,
        userId: sessionStorage.getItem("user-id") || "",
        sourceApp: "insurpro",
      }
    );

    if (response?.success) {
      let data = {
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
        documentId: response.data.id,
        status: response.success,
      };

      setFileData(data);
      formOne.setFieldValue(`${field}`, data, true);
      setLoading(false);
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
    } else {
      setFile(null);
      setLoading(false);
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        })
      );
    }
  };

  const downloadAttachment = async (id, name) => {
    const response = await downloadFile(id, name);
  };

  const deleteFile = async (id) => {
    const response = await deleteDocument(id);
    formOne.setFieldValue(
      `${field}`,
      {
        fileName: "",
        fileType: "",
        fileSize: "",
        documentId: "",
        status: "",
      },
      true
    );
    setFileData({});

    // if (response?.success) {
    //   setFileData({});
    //   dispatch(
    //     pushNotification({
    //       isOpen: true,
    //       type: CONSTANTS.SUCCESS,
    //       message: response?.message,
    //     })
    //   );
    // } else {
    //   dispatch(
    //     pushNotification({
    //       isOpen: true,
    //       type: CONSTANTS.ERROR,
    //       message: response?.message,
    //     })
    //   );
    // }
  };

  useEffect(() => {
    setFileData(formOne.values[`${field}`] || {});
  }, [formOne]);

  return (
    <div className={classes.fileUploadContainer}>
      <div className={classes.DocumentTitleContainer}>{title}</div>
      {loading && <CircularProgress color="primary" />}

      <div>
        {!fileData?.documentId && !loading && (
          <>
            <FileUploader
              handleChange={handleFileChange}
              name="file"
              types={fileTypes}
            />
            <FormHelperText className="formikFieldsErrorColor">
              {formOne?.touched[`${field}`]?.documentId &&
                formOne?.errors[`${field}`]?.documentId}
            </FormHelperText>
          </>
        )}

        {fileData?.documentId && !loading && (
          <div className={classes.fileDisplayConatiner}>
            {fileData.fileType === "image/png" && (
              <img
                className={classes.fileTypeImg}
                src="https://cdn-icons-png.flaticon.com/512/337/337948.png"
              />
            )}
            {fileData.fileType === "application/pdf" && (
              <img
                className={classes.fileTypeImg}
                src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
              />
            )}
            {fileData.fileType === "image/jpg" && (
              <img
                className={classes.fileTypeImg}
                src="https://www.svgrepo.com/show/255826/jpg.svg"
              />
            )}
            {fileData.fileType === "doc" && (
              <img
                className={classes.fileTypeImg}
                src="https://www.svgrepo.com/show/255810/doc.svg"
              />
            )}

            {fileData.fileType === "text/csv" && (
              <img
                className={classes.fileTypeImg}
                src="https://cdn-icons-png.flaticon.com/512/172/172534.png"
              />
            )}

            {fileData.fileType === "image/jpeg" && (
              <img
                className={classes.fileTypeImg}
                src="https://cdn-icons-png.flaticon.com/512/337/337940.png"
              />
            )}

            {fileData.fileType === "text/plain" && (
              <img
                className={classes.fileTypeImg}
                src="https://cdn-icons-png.flaticon.com/512/2656/2656402.png"
              />
            )}

            {fileData.fileType ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" && (
              <img
                className={classes.fileTypeImg}
                src="https://img.icons8.com/external-fauzidea-flat-fauzidea/256/external-docx-file-file-extension-fauzidea-flat-fauzidea.png"
              />
            )}

            {fileData.fileType ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && (
              <img
                className={classes.fileTypeImg}
                src="https://cdn-icons-png.flaticon.com/512/9496/9496502.png"
              />
            )}

            <div className={classes.fileTitle}>{fileData.fileName}</div>
            <div>
              <Tooltip title={"Download"}>
                <IconButton
                  onClick={() =>
                    downloadAttachment(fileData.documentId, fileData.fileName)
                  }
                >
                  <FileDownloadOutlinedIcon color="secondary" />
                </IconButton>
              </Tooltip>
            </div>
            <div>
              <Tooltip title={"Delete"}>
                <IconButton
                  onClick={() => deleteFile(fileData.documentId)}
                  color="primary"
                >
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </Tooltip>
            </div>

            <div>
              {fileData.status ? (
                <Tooltip title={"Success"}>
                  <IconButton>
                    <CheckCircleIcon className={classes.uploadSuccess} />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={"Failed"}>
                  <IconButton>
                    <ErrorIcon className={classes.uploadFailed} />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentUpload;
